/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyNumbers
 */
export interface EmergencyNumbers {
    /**
     * 
     * @type {string}
     * @memberof EmergencyNumbers
     */
    fire: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyNumbers
     */
    medical: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyNumbers
     */
    police: string;
}

/**
 * Check if a given object implements the EmergencyNumbers interface.
 */
export function instanceOfEmergencyNumbers(value: object): value is EmergencyNumbers {
    if (!('fire' in value) || value['fire'] === undefined) return false;
    if (!('medical' in value) || value['medical'] === undefined) return false;
    if (!('police' in value) || value['police'] === undefined) return false;
    return true;
}

export function EmergencyNumbersFromJSON(json: any): EmergencyNumbers {
    return EmergencyNumbersFromJSONTyped(json, false);
}

export function EmergencyNumbersFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyNumbers {
    if (json == null) {
        return json;
    }
    return {
        
        'fire': json['fire'],
        'medical': json['medical'],
        'police': json['police'],
    };
}

export function EmergencyNumbersToJSON(json: any): EmergencyNumbers {
    return EmergencyNumbersToJSONTyped(json, false);
}

export function EmergencyNumbersToJSONTyped(value?: EmergencyNumbers | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fire': value['fire'],
        'medical': value['medical'],
        'police': value['police'],
    };
}

